import React from 'react';
import { Typography } from '@mui/material';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface TrendIndicatorProps {
    direction: 'up' | 'down' | 'flat';
    value: number;
}

export const TrendIndicator: React.FC<TrendIndicatorProps> = ({ direction, value }) => {
    const color = direction === 'up'
        ? COLORS.green
        : direction === 'down'
            ? COLORS.red
            : COLORS.grayMedium;

    const symbol = direction === 'up'
        ? '↑'
        : direction === 'down'
            ? '↓'
            : '—';

    return (
        <Typography
            component="span"
            sx={{
                fontSize: '11px',
                fontWeight: 600,
                color,
            }}
        >
            {symbol} {value}%
        </Typography>
    );
};
